import { Link } from "react-router-dom";
import { Navigation } from "react-minimal-side-navigation";
import { history } from "../_helpers";
// import { useHistory } from 'react-router-dom';
import Nav from "../Page/nav";
import AdSenseAd from "../Page/AdSenseAd";

import { useDispatch, useSelector } from "react-redux";
import "react-minimal-side-navigation/lib/ReactMinimalSideNavigation.css";
import React, { useState, useEffect } from "react";

const Header = () => {
    // const histor = useHistory(); 

  function openFuncation() {
    var element = document.getElementById("navid");
    element.classList.add("show-menu");
    document.getElementById("closefunctionalities").style.display = "block";

  }
  function closeFuncation() {
    var element = document.getElementById("navid");
    element.classList.remove("show-menu");
      document.getElementById("closefunctionalities").style.display = "none";
  }
   // const closeFuncation = ()=>{
   //      document.getElementById("navid").style.display = "none";
   //  }

  return (
    <>
 <nav className="navdesign"></nav>
    <header id="header" className="d-flex align-items-center ">
    
    <div className="container-fluid container-xxl d-flex align-items-center">

      <div id="logo" className="me-auto">
    
        <a href="index.html" className="scrollto"><img src={"../assets/img/logo.png"} alt="" title="" /></a>
      </div>


      <Nav/>
    <AdSenseAd slot="4706915783" />

    </div>
  </header>

    </>
  );
}
export default Header;
